import { useSnackbar } from "notistack";
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import ReactGA from "react-ga4";
// import Spinner from "../components/Spinner";

// const EditProduct = () => {

const AcessarLoja = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title: "tela_de_login_atleta",
    });
  }, []);

  const handleAcesso = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/auth/acesso`,
        { password: password.toUpperCase() }
        // config
      );

      if (response.data.user.perfil === "Atleta") {
        localStorage.setItem("tokenAcesso", response.data.token);
        localStorage.setItem("user", JSON.stringify(response.data.user));
      } else {
        enqueueSnackbar("Área exclusiva para atletas", {
          variant: "warning",
        });
        navigate("/games");
      }

      navigate("/ar/shop");
    } catch (error) {
      enqueueSnackbar("Código inválido", {
        variant: "warning",
      });
      if (error.response) {
        setStatusMessage(error.response.data.msg);
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log("Error", error.message);
      }
    }
  };

  //   const [loading, setLoading] = useState(false);
  return (
    <div className="p-6 bg-base-100 flex justify-center items-center mt-20">
      <div className="container max-w-lg shadow-lg rounded-lg p-5 bg-base-100">
        <div className="justify-center flex mt-4 flex-col">
          <h1 className="text-3xl font-semibold text-center">Acesso à loja</h1>
          <form
            className="w-full mx-auto max-w-xs mt-12"
            onSubmit={handleAcesso}
          >
            <div className="my-2">
              <label htmlFor="mensagem" className="block text-md  mb-2">
                Digite o código que o Adauto te passou.
              </label>

              <input
                id="password"
                type="password"
                value={password}
                placeholder="Código"
                onChange={(e) => setPassword(e.target.value)}
                className="border border-base-300 px-4 py-2 w-full rounded-md"
                required
              />

              <button
                type="submit"
                className="w-full bg-green-500
                              hover:bg-green-800 text-white py-2 px-4 rounded-md my-12"
              >
                Entrar
              </button>
              <p className="mb-4">
                Ainda não tem código? Só me chamar no Whatsapp:
                <a
                  className="link flex justify-center align-bottom text-green-950"
                  href="http://wa.me/5511976006882/?text=Oi,%20Adauto.%20Preciso%20de%20um%20código%20de%20acesso."
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="50px"
                    width="50px"
                    viewBox="0 0 448 512"
                  >
                    <path
                      fill="green"
                      d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7 .9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
                    />
                  </svg>
                </a>
              </p>
              <Link to="/" className="btn mt-5">
                Voltar
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AcessarLoja;
